import { render, staticRenderFns } from "./order-recap.vue?vue&type=template&id=2d2d8eea&scoped=true&"
import script from "./order-recap.vue?vue&type=script&lang=js&"
export * from "./order-recap.vue?vue&type=script&lang=js&"
import style0 from "./order-recap.vue?vue&type=style&index=0&id=2d2d8eea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2d8eea",
  null
  
)

export default component.exports